import { CompanyDataDto, IndividualDataDto } from '@app/store/models';
import { ContractorType } from '@app/store/types';
import { UserValue } from './user.value';

export class UserValueDto {
    firstName: string;
    lastName: string;
    pseudonym: string;
    phoneNumber: string;
    avatar: string | null;
    contractorType?: ContractorType;
    contractorData?: CompanyDataDto | IndividualDataDto;

    constructor(userValue: UserValue) {
        this.contractorType = userValue.contractorData.type;
        this.firstName = userValue.firstName.trim();
        this.lastName = userValue.lastName.trim();
        this.pseudonym = userValue.pseudonym.trim();
        this.phoneNumber = userValue.phoneNumber.trim();
        this.avatar = userValue.avatar;

        switch (userValue.contractorData.type) {
            case 'individual': {
                this.contractorData = <IndividualDataDto>{
                    city: userValue.contractorData.city,
                    street: userValue.contractorData.street,
                    streetNumber: userValue.contractorData.streetNumber,
                    zipCode: userValue.contractorData.zipCode,
                    nin: userValue.contractorData.nin,
                    taxOfficeAddress: userValue.contractorData.taxOfficeAddress,
                };
                break;
            }

            case 'company': {
                this.contractorData = <CompanyDataDto>{
                    city: userValue.contractorData.city,
                    street: userValue.contractorData.street,
                    streetNumber: userValue.contractorData.streetNumber,
                    zipCode: userValue.contractorData.zipCode,
                    apartmentNumber: userValue.contractorData.apartmentNumber,
                    companyName: userValue.contractorData.companyName,
                    vatin: userValue.contractorData.vatin,
                };
                break;
            }
        }
    }
}
